import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linux-sdc3-series',
  templateUrl: './linux-sdc3-series.component.html',
  styleUrls: []
})
export class LinuxSdc3SeriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}